import { render, staticRenderFns } from "./TicketPortrait.vue?vue&type=template&id=2dff4bae&scoped=true&"
import script from "./TicketPortrait.vue?vue&type=script&lang=js&"
export * from "./TicketPortrait.vue?vue&type=script&lang=js&"
import style0 from "./TicketPortrait.vue?vue&type=style&index=0&id=2dff4bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff4bae",
  null
  
)

export default component.exports